import { getBanners } from "@/actions/banner.action";
import { BannerItem, BannerResponse } from "@/types/core";
import { useQuery } from "@tanstack/react-query";

/**
 * A custom hook to get banners for home page
 * @returns {
 *   data: BannerItem[],
 *   isLoading: boolean,
 *   isError: boolean,
 *   error: Error
 * }
 */
export const useBanner = () => {
  return useQuery<BannerResponse, Error, BannerItem[]>({
    queryKey: ["banners"],
    queryFn: getBanners,
    staleTime: 1000 * 60 * 5,
    select: (res) => res.data,
  });
};
